export default __webpack_public_path__ + "static/ak-cached/24h/media/fcpTv.012f6d09.jpg";